module.exports = {"522635001":"杏山街道","522635002":"金竹街道","522635101":"谷硐镇","522635103":"宣威镇","522635105":"龙山镇","522635106":"贤昌镇","522635203":"坝芒布依族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/522635.json
// module id = 2336
// module chunks = 0